// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#AdminOpsDemoPage {
  justify-content: flex-start;
}
#AdminOpsDemoPage .ops-demo-body {
  width: 100%;
  height: calc(100vh - var(--page-header-height));
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 0 16px 60px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
#AdminOpsDemoPage .ops-demo-card {
  background: var(--white-color-lightest);
  border-radius: 8px;
  padding: 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 28px;
}
#AdminOpsDemoPage .ops-demo-card hr {
  margin: 0;
}
#AdminOpsDemoPage .ops-demo-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
}
#AdminOpsDemoPage .ops-demo-label {
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}
#AdminOpsDemoPage .ops-demo-label .ops-demo-label-text {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 1px;
}
#AdminOpsDemoPage .ops-demo-required {
  color: var(--primary-color-main);
  font-size: 12px;
  font-weight: 600;
}
#AdminOpsDemoPage .ops-demo-label-hint, #AdminOpsDemoPage .ops-demo-form-hint, #AdminOpsDemoPage .ops-demo-sec-unit, #AdminOpsDemoPage .ops-demo-sec-hint {
  font-size: 12px;
  color: var(--font_active_sub_color);
  text-align: left;
}
#AdminOpsDemoPage .ops-demo-form {
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
#AdminOpsDemoPage .ops-demo-form.is-reload {
  gap: 12px;
}
#AdminOpsDemoPage .ops-demo-mono {
  font-family: var(--ops-mono);
  font-size: 14px;
}
#AdminOpsDemoPage .ops-demo-form-error {
  font-size: 12px;
  font-weight: 600;
  color: var(--ops-error);
  text-align: left;
}
#AdminOpsDemoPage .ops-demo-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  width: fit-content;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
#AdminOpsDemoPage .ops-demo-switch input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
#AdminOpsDemoPage .ops-demo-switch .switch-track {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
  flex-shrink: 0;
  background-color: var(--dark-color-light);
  border-radius: 999px;
  transition: background-color 0.2s;
}
#AdminOpsDemoPage .ops-demo-switch .switch-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  background-color: var(--white-color-lightest);
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}
#AdminOpsDemoPage .ops-demo-switch .switch-label {
  font-size: 14px;
}
#AdminOpsDemoPage .ops-demo-switch.on .switch-track {
  background-color: var(--primary-color-main);
}
#AdminOpsDemoPage .ops-demo-switch.on .switch-thumb {
  transform: translateX(24px);
}
#AdminOpsDemoPage .ops-demo-sec-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
#AdminOpsDemoPage .ops-demo-sec-row .ops-demo-sec-input {
  width: 160px;
}
#AdminOpsDemoPage .ops-demo-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding-top: 4px;
}
#AdminOpsDemoPage .ops-demo-actions .ops-demo-info {
  width: 70%;
  box-sizing: border-box;
}
#AdminOpsDemoPage .ops-demo-result {
  background: var(--white-color-lightest);
  border-radius: 8px;
  padding: 32px;
  box-sizing: border-box;
  border-left: 4px solid var(--success-color-main);
  display: flex;
  flex-direction: column;
  gap: 16px;
}
#AdminOpsDemoPage .ops-demo-result-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
#AdminOpsDemoPage .ops-demo-result-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: var(--ops-inuse-fg);
}
#AdminOpsDemoPage .ops-demo-result-title .bi {
  font-size: 18px;
}
#AdminOpsDemoPage .ops-demo-result-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: var(--ops-inuse-bg);
  color: var(--ops-inuse-fg);
  border: 1px solid var(--ops-inuse-border);
}
#AdminOpsDemoPage .ops-demo-result-url {
  font-size: 13px;
  font-family: var(--ops-mono);
  color: var(--font_active_sub_color);
  word-break: break-all;
  background: var(--input-bg-color);
  border-radius: 6px;
  padding: 12px;
  text-align: left;
}
#AdminOpsDemoPage .ops-demo-result-actions {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
}
#AdminOpsDemoPage .ops-demo-result-btn {
  min-height: 40px;
  padding: 8px 20px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: transparent;
  color: var(--font_active_sub_color);
  font-weight: 600;
  letter-spacing: 1px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
#AdminOpsDemoPage .ops-demo-result-btn .bi {
  font-size: 16px;
}
#AdminOpsDemoPage .ops-demo-result-btn:hover {
  background: var(--dark-color-dark-transparent-10);
}
#AdminOpsDemoPage .ops-demo-result-btn.is-primary {
  border-color: var(--primary-color-main);
  background: var(--primary-color-main);
  color: var(--white-color-light);
}
#AdminOpsDemoPage .ops-demo-result-btn.is-primary:hover {
  background: var(--primary-color-dark);
  border-color: var(--primary-color-dark);
}
#AdminOpsDemoPage .ops-demo-card.is-dialog {
  padding: 32px;
  gap: 24px;
}
#AdminOpsDemoPage .ops-demo-fixed-name {
  font-family: var(--ops-mono);
  font-size: 14px;
  text-align: left;
  word-break: break-all;
  padding: 10px 12px;
  border-radius: 6px;
  background: var(--input-bg-color);
  color: var(--font_active_sub_color);
}
#AdminOpsDemoPage .ops-demo-list {
  background: var(--white-color-lightest);
  border-radius: 8px;
  padding: 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
#AdminOpsDemoPage .ops-demo-list-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 16px;
}
#AdminOpsDemoPage .ops-demo-list-heading {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}
#AdminOpsDemoPage .ops-demo-list-title {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 1px;
}
#AdminOpsDemoPage .ops-demo-list-note {
  font-size: 12px;
  color: var(--font_active_sub_color);
}
#AdminOpsDemoPage .ops-demo-list-count {
  flex-shrink: 0;
  font-size: 12px;
  color: var(--font_active_hidden_color);
}
#AdminOpsDemoPage .ops-demo-list-loading {
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
#AdminOpsDemoPage .ops-demo-list-empty {
  padding: 24px 8px;
  font-size: 13px;
  color: var(--font_active_hidden_color);
}
#AdminOpsDemoPage .ops-demo-table {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: auto;
  font-size: 14px;
  text-align: left;
}
#AdminOpsDemoPage .ops-demo-tr {
  display: flex;
  min-height: 35px;
  min-width: 720px;
}
#AdminOpsDemoPage .ops-demo-tr:not(.is-head):hover {
  background: var(--dark-color-dark-transparent-10);
}
#AdminOpsDemoPage .ops-demo-tr.is-head .ops-demo-td {
  padding: 0 8px;
  height: 35px;
  font-size: 12px;
  color: var(--font_active_sub_color);
}
#AdminOpsDemoPage .ops-demo-td {
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 12px 8px;
  border-bottom: 1px solid var(--border-weak-color);
  box-sizing: border-box;
}
#AdminOpsDemoPage .ops-demo-td.is-name {
  flex: 2 1;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
}
#AdminOpsDemoPage .ops-demo-td.is-title {
  flex: 3 1;
  word-break: break-word;
}
#AdminOpsDemoPage .ops-demo-td.is-reload {
  width: 88px;
  min-width: 88px;
  font-size: 13px;
}
#AdminOpsDemoPage .ops-demo-td.is-date {
  width: 170px;
  min-width: 170px;
  font-size: 12px;
  font-family: var(--ops-mono);
  color: var(--font_active_sub_color);
}
#AdminOpsDemoPage .ops-demo-td.is-actions {
  width: 120px;
  min-width: 120px;
  justify-content: flex-end;
  gap: 4px;
}
#AdminOpsDemoPage .ops-demo-td.is-empty {
  color: var(--font_active_hidden_color);
}
#AdminOpsDemoPage .ops-demo-page-name {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-family: var(--ops-mono);
  font-size: 13px;
  word-break: break-all;
}
#AdminOpsDemoPage .ops-demo-lock-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 7px;
  border-radius: 999px;
  font-family: inherit;
  font-size: 10.5px;
  font-weight: 700;
  background: var(--ops-warn-bg);
  color: var(--ops-warn-text);
  border: 1px solid var(--ops-warn-border);
}
#AdminOpsDemoPage .ops-demo-lock-badge .bi {
  font-size: 10px;
}
#AdminOpsDemoPage .ops-demo-lock-note {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: var(--ops-warn-bg);
  border: 1px solid var(--ops-warn-border);
  color: var(--ops-warn-text);
  text-align: left;
}
#AdminOpsDemoPage .ops-demo-lock-note .bi {
  font-size: 18px;
  flex-shrink: 0;
}
#AdminOpsDemoPage .ops-demo-lock-note code {
  font-family: var(--ops-mono);
  font-size: 12px;
}
#AdminOpsDemoPage .ops-demo-lock-note-title {
  font-size: 14px;
  font-weight: 700;
}
#AdminOpsDemoPage .ops-demo-lock-note-text {
  margin-top: 2px;
  font-size: 12px;
  line-height: 1.7;
}
#AdminOpsDemoPage .ops-demo-page-url {
  font-size: 10.5px;
  color: var(--input-placeholder-color);
  word-break: break-all;
}
#AdminOpsDemoPage .ops-demo-icon-btn {
  width: 28px;
  height: 28px;
  min-height: 28px;
  padding: 0;
  border-radius: 14px;
  border: 1px solid var(--border-weak-color);
  background: var(--white-color-lightest);
  color: var(--font_active_sub_color);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
#AdminOpsDemoPage .ops-demo-icon-btn .bi {
  font-size: 13px;
}
#AdminOpsDemoPage .ops-demo-icon-btn:hover {
  background: var(--dark-color-main);
  color: var(--white-color-main);
  border-color: var(--dark-color-main);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/parts/ops/AdminOpsDemoPage.scss"],"names":[],"mappings":"AACA;EACI,2BAAA;AAAJ;AAEI;EACI,WAAA;EACA,+CAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAAR;AAGI;EACI,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADR;AAGQ;EACI,SAAA;AADZ;AAKI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AAHR;AAMI;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAJR;AAMQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAJZ;AAQI;EACI,gCAAA;EACA,eAAA;EACA,gBAAA;AANR;AASI;EACI,eAAA;EACA,mCAAA;EACA,gBAAA;AAPR;AAUI;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AARR;AAUQ;EACI,SAAA;AARZ;AAYI;EACI,4BAAA;EACA,eAAA;AAVR;AAaI;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAXR;AAeI;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAbR;AAeQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;AAbZ;AAgBQ;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,yCAAA;EACA,oBAAA;EACA,iCAAA;AAdZ;AAiBQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;EACA,kBAAA;EACA,wCAAA;EACA,0BAAA;AAfZ;AAkBQ;EACI,eAAA;AAhBZ;AAoBY;EACI,2CAAA;AAlBhB;AAoBY;EACI,2BAAA;AAlBhB;AAuBI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AArBR;AAuBQ;EACI,YAAA;AArBZ;AAyBI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAvBR;AAyBQ;EACI,UAAA;EACA,sBAAA;AAvBZ;AA2BI;EACI,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gDAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAzBR;AA4BI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA1BR;AA6BI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,0BAAA;AA3BR;AA6BQ;EACI,eAAA;AA3BZ;AA+BI;EACI,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,0BAAA;EACA,yCAAA;AA7BR;AAgCI;EACI,eAAA;EACA,4BAAA;EACA,mCAAA;EACA,qBAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AA9BR;AAiCI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AA/BR;AAkCI;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,uBAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAhCR;AAkCQ;EACI,eAAA;AAhCZ;AAmCQ;EACI,iDAAA;AAjCZ;AAoCQ;EACI,uCAAA;EACA,qCAAA;EACA,+BAAA;AAlCZ;AAoCY;EACI,qCAAA;EACA,uCAAA;AAlChB;AAwCI;EACI,aAAA;EACA,SAAA;AAtCR;AAyCI;EACI,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mCAAA;AAvCR;AA2CI;EACI,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAzCR;AA4CI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;AA1CR;AA6CI;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AA3CR;AA8CI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AA5CR;AA+CI;EACI,eAAA;EACA,mCAAA;AA7CR;AAgDI;EACI,cAAA;EACA,eAAA;EACA,sCAAA;AA9CR;AAiDI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA/CR;AAkDI;EACI,iBAAA;EACA,eAAA;EACA,sCAAA;AAhDR;AAmDI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAjDR;AAoDI;EACI,aAAA;EACA,gBAAA;EAEA,gBAAA;AAnDR;AAqDQ;EACI,iDAAA;AAnDZ;AAsDQ;EACI,cAAA;EACA,YAAA;EACA,eAAA;EACA,mCAAA;AApDZ;AAwDI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,iDAAA;EACA,sBAAA;AAtDR;AAwDQ;EACI,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;AAtDZ;AAyDQ;EACI,SAAA;EACA,sBAAA;AAvDZ;AA0DQ;EACI,WAAA;EACA,eAAA;EACA,eAAA;AAxDZ;AA2DQ;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,mCAAA;AAzDZ;AA4DQ;EACI,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,QAAA;AA1DZ;AA6DQ;EACI,sCAAA;AA3DZ;AA+DI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,4BAAA;EACA,eAAA;EACA,qBAAA;AA7DR;AAgEI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,2BAAA;EACA,wCAAA;AA9DR;AAgEQ;EAAM,eAAA;AA7Dd;AAiEI;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,wCAAA;EACA,2BAAA;EACA,gBAAA;AA/DR;AAiEQ;EAAM,eAAA;EAAiB,cAAA;AA7D/B;AA+DQ;EACI,4BAAA;EACA,eAAA;AA7DZ;AAiEI;EACI,eAAA;EACA,gBAAA;AA/DR;AAkEI;EACI,eAAA;EACA,eAAA;EACA,gBAAA;AAhER;AAmEI;EACI,iBAAA;EACA,qCAAA;EACA,qBAAA;AAjER;AAoEI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,0CAAA;EACA,uCAAA;EACA,mCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAlER;AAoEQ;EACI,eAAA;AAlEZ;AAqEQ;EACI,kCAAA;EACA,8BAAA;EACA,oCAAA;AAnEZ","sourcesContent":["// デモページ作成（デザイン PRizmo_Admin.dc.html L3115-3204）\n#AdminOpsDemoPage {\n    justify-content: flex-start;\n\n    .ops-demo-body {\n        width: 100%;\n        height: calc(100vh - var(--page-header-height));\n        overflow-y: auto;\n        overflow-x: hidden;\n        box-sizing: border-box;\n        padding: 0 16px 60px;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .ops-demo-card {\n        background: var(--white-color-lightest);\n        border-radius: 8px;\n        padding: 40px;\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        gap: 28px;\n\n        hr {\n            margin: 0;\n        }\n    }\n\n    .ops-demo-row {\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        gap: 16px;\n        width: 100%;\n    }\n\n    .ops-demo-label {\n        width: 30%;\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        text-align: left;\n\n        .ops-demo-label-text {\n            font-size: 18px;\n            font-weight: 800;\n            letter-spacing: 1px;\n        }\n    }\n\n    .ops-demo-required {\n        color: var(--primary-color-main);\n        font-size: 12px;\n        font-weight: 600;\n    }\n\n    .ops-demo-label-hint, .ops-demo-form-hint, .ops-demo-sec-unit, .ops-demo-sec-hint {\n        font-size: 12px;\n        color: var(--font_active_sub_color);\n        text-align: left;\n    }\n\n    .ops-demo-form {\n        width: 70%;\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n\n        &.is-reload {\n            gap: 12px;\n        }\n    }\n\n    .ops-demo-mono {\n        font-family: var(--ops-mono);\n        font-size: 14px;\n    }\n\n    .ops-demo-form-error {\n        font-size: 12px;\n        font-weight: 600;\n        color: var(--ops-error);\n        text-align: left;\n    }\n\n    // ON/OFF トグル（有人引き継ぎ設定のスイッチと同じ寸法）\n    .ops-demo-switch {\n        position: relative;\n        display: inline-flex;\n        align-items: center;\n        gap: 12px;\n        width: fit-content;\n        cursor: pointer;\n        user-select: none;\n\n        input[type=\"checkbox\"] {\n            position: absolute;\n            opacity: 0;\n            width: 0;\n            height: 0;\n            pointer-events: none;\n        }\n\n        .switch-track {\n            position: relative;\n            display: inline-block;\n            width: 52px;\n            height: 28px;\n            flex-shrink: 0;\n            background-color: var(--dark-color-light);\n            border-radius: 999px;\n            transition: background-color 0.2s;\n        }\n\n        .switch-thumb {\n            position: absolute;\n            top: 3px;\n            left: 3px;\n            width: 22px;\n            height: 22px;\n            background-color: var(--white-color-lightest);\n            border-radius: 50%;\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n            transition: transform 0.2s;\n        }\n\n        .switch-label {\n            font-size: 14px;\n        }\n\n        &.on {\n            .switch-track {\n                background-color: var(--primary-color-main);\n            }\n            .switch-thumb {\n                transform: translateX(24px);\n            }\n        }\n    }\n\n    .ops-demo-sec-row {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 12px;\n        flex-wrap: wrap;\n\n        .ops-demo-sec-input {\n            width: 160px;\n        }\n    }\n\n    .ops-demo-actions {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 24px;\n        padding-top: 4px;\n\n        .ops-demo-info {\n            width: 70%;\n            box-sizing: border-box;\n        }\n    }\n\n    .ops-demo-result {\n        background: var(--white-color-lightest);\n        border-radius: 8px;\n        padding: 32px;\n        box-sizing: border-box;\n        border-left: 4px solid var(--success-color-main);\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .ops-demo-result-head {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        gap: 16px;\n    }\n\n    .ops-demo-result-title {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-weight: 700;\n        color: var(--ops-inuse-fg);\n\n        .bi {\n            font-size: 18px;\n        }\n    }\n\n    .ops-demo-result-badge {\n        display: inline-flex;\n        align-items: center;\n        padding: 3px 10px;\n        border-radius: 999px;\n        font-size: 11px;\n        font-weight: 700;\n        background: var(--ops-inuse-bg);\n        color: var(--ops-inuse-fg);\n        border: 1px solid var(--ops-inuse-border);\n    }\n\n    .ops-demo-result-url {\n        font-size: 13px;\n        font-family: var(--ops-mono);\n        color: var(--font_active_sub_color);\n        word-break: break-all;\n        background: var(--input-bg-color);\n        border-radius: 6px;\n        padding: 12px;\n        text-align: left;\n    }\n\n    .ops-demo-result-actions {\n        display: flex;\n        flex-direction: row;\n        gap: 12px;\n        flex-wrap: wrap;\n    }\n\n    .ops-demo-result-btn {\n        min-height: 40px;\n        padding: 8px 20px;\n        border-radius: 8px;\n        border: 1px solid var(--border-color);\n        background: transparent;\n        color: var(--font_active_sub_color);\n        font-weight: 600;\n        letter-spacing: 1px;\n        font-size: 14px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        .bi {\n            font-size: 16px;\n        }\n\n        &:hover {\n            background: var(--dark-color-dark-transparent-10);\n        }\n\n        &.is-primary {\n            border-color: var(--primary-color-main);\n            background: var(--primary-color-main);\n            color: var(--white-color-light);\n\n            &:hover {\n                background: var(--primary-color-dark);\n                border-color: var(--primary-color-dark);\n            }\n        }\n    }\n\n    // 設定変更モーダルの中の入力カード\n    .ops-demo-card.is-dialog {\n        padding: 32px;\n        gap: 24px;\n    }\n\n    .ops-demo-fixed-name {\n        font-family: var(--ops-mono);\n        font-size: 14px;\n        text-align: left;\n        word-break: break-all;\n        padding: 10px 12px;\n        border-radius: 6px;\n        background: var(--input-bg-color);\n        color: var(--font_active_sub_color);\n    }\n\n    // 作成済みデモページ一覧（デザイン PRizmo_Admin.dc.html L3244-3302）\n    .ops-demo-list {\n        background: var(--white-color-lightest);\n        border-radius: 8px;\n        padding: 32px;\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n    }\n\n    .ops-demo-list-head {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        flex-wrap: wrap;\n        gap: 8px 16px;\n    }\n\n    .ops-demo-list-heading {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        text-align: left;\n    }\n\n    .ops-demo-list-title {\n        font-size: 18px;\n        font-weight: 800;\n        letter-spacing: 1px;\n    }\n\n    .ops-demo-list-note {\n        font-size: 12px;\n        color: var(--font_active_sub_color);\n    }\n\n    .ops-demo-list-count {\n        flex-shrink: 0;\n        font-size: 12px;\n        color: var(--font_active_hidden_color);\n    }\n\n    .ops-demo-list-loading {\n        min-height: 80px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .ops-demo-list-empty {\n        padding: 24px 8px;\n        font-size: 13px;\n        color: var(--font_active_hidden_color);\n    }\n\n    .ops-demo-table {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        overflow-x: auto;\n        font-size: 14px;\n        text-align: left;\n    }\n\n    .ops-demo-tr {\n        display: flex;\n        min-height: 35px;\n        // 狭い画面では列を潰さず横スクロールにする\n        min-width: 720px;\n\n        &:not(.is-head):hover {\n            background: var(--dark-color-dark-transparent-10);\n        }\n\n        &.is-head .ops-demo-td {\n            padding: 0 8px;\n            height: 35px;\n            font-size: 12px;\n            color: var(--font_active_sub_color);\n        }\n    }\n\n    .ops-demo-td {\n        display: flex;\n        align-items: center;\n        min-width: 0;\n        padding: 12px 8px;\n        border-bottom: 1px solid var(--border-weak-color);\n        box-sizing: border-box;\n\n        &.is-name {\n            flex: 2;\n            flex-direction: column;\n            align-items: flex-start;\n            justify-content: center;\n            gap: 2px;\n        }\n\n        &.is-title {\n            flex: 3;\n            word-break: break-word;\n        }\n\n        &.is-reload {\n            width: 88px;\n            min-width: 88px;\n            font-size: 13px;\n        }\n\n        &.is-date {\n            width: 170px;\n            min-width: 170px;\n            font-size: 12px;\n            font-family: var(--ops-mono);\n            color: var(--font_active_sub_color);\n        }\n\n        &.is-actions {\n            width: 120px;\n            min-width: 120px;\n            justify-content: flex-end;\n            gap: 4px;\n        }\n\n        &.is-empty {\n            color: var(--font_active_hidden_color);\n        }\n    }\n\n    .ops-demo-page-name {\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 6px;\n        font-family: var(--ops-mono);\n        font-size: 13px;\n        word-break: break-all;\n    }\n\n    .ops-demo-lock-badge {\n        display: inline-flex;\n        align-items: center;\n        gap: 3px;\n        padding: 1px 7px;\n        border-radius: 999px;\n        font-family: inherit;\n        font-size: 10.5px;\n        font-weight: 700;\n        background: var(--ops-warn-bg);\n        color: var(--ops-warn-text);\n        border: 1px solid var(--ops-warn-border);\n\n        .bi { font-size: 10px; }\n    }\n\n    // 設定変更モーダル: ロック中の案内\n    .ops-demo-lock-note {\n        display: flex;\n        align-items: flex-start;\n        gap: 10px;\n        margin-bottom: 16px;\n        padding: 12px 16px;\n        border-radius: 8px;\n        background: var(--ops-warn-bg);\n        border: 1px solid var(--ops-warn-border);\n        color: var(--ops-warn-text);\n        text-align: left;\n\n        .bi { font-size: 18px; flex-shrink: 0; }\n\n        code {\n            font-family: var(--ops-mono);\n            font-size: 12px;\n        }\n    }\n\n    .ops-demo-lock-note-title {\n        font-size: 14px;\n        font-weight: 700;\n    }\n\n    .ops-demo-lock-note-text {\n        margin-top: 2px;\n        font-size: 12px;\n        line-height: 1.7;\n    }\n\n    .ops-demo-page-url {\n        font-size: 10.5px;\n        color: var(--input-placeholder-color);\n        word-break: break-all;\n    }\n\n    .ops-demo-icon-btn {\n        width: 28px;\n        height: 28px;\n        min-height: 28px;\n        padding: 0;\n        border-radius: 14px;\n        border: 1px solid var(--border-weak-color);\n        background: var(--white-color-lightest);\n        color: var(--font_active_sub_color);\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n\n        .bi {\n            font-size: 13px;\n        }\n\n        &:hover {\n            background: var(--dark-color-main);\n            color: var(--white-color-main);\n            border-color: var(--dark-color-main);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
